import { Input, Tooltip, Pagination } from "antd";
import { BsArrowDownUp } from "react-icons/bs";
import { TranslateString } from "Utils/Common";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons"
import { useState, useEffect } from "react";
import { useIntl } from 'react-intl';
import SingleLoanServices from "services/services/SingleLoanServices";

const BankNameList = (props: any) => {

    const intl = useIntl();


    useEffect(() => {
        props?.getAllBankName();
    }, [props?.searchBankNameData, props?.pageData])

    const onSearch = (event: any) => {
        const { target } = event;
        const value = target.value;
        const name = target.name;

        props?.setSearchBankNameData({ ...props?.searchBankNameData, [name]: value });
    }

    return (
        <>
            <div className='cu-table-border'>
                <div className="overflow-auto" style={{ maxHeight: '210px' }}>
                    <table className="table table-sm table-bordered table-striped text-left m-0">
                        <thead>
                            <tr className="align-middle cu-text-small">
                                <td className="cu-bg-green fw-bold">{TranslateString('bank_name')}</td>
                                <td className="cu-bg-green fw-bold text-center">{TranslateString('actions')}</td>
                            </tr>
                            <tr className="align-middle">
                                <td className="cu-bg-green" style={{ width: "10%" }}><Input placeholder={TranslateString('search')}
                                suffix={<BsArrowDownUp
                                    onClick={() => {
                                        props?.setSearchBankNameData({ ...props?.setSearchBankNameData, sort_by: "bank_name" })
                                        props?.setBankNameSort(!props?.bankNameSort)
                                    }
                                    }
                                    role={"button"} />} onChange={onSearch} name="bank_name" /></td>
                                <td className="cu-bg-green" style={{ width: "10%" }}></td>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                (() => {
                                    let startFrom = props?.paginationData?.pageSize * (props?.paginationData?.page - 1);
                                    let endFrom = startFrom + props?.paginationData?.pageSize;
                                    return props?.bankNameList?.slice(startFrom, endFrom).map((element: any, index: any) => {
                                        return (
                                            <tr key={Math.random()}>
                                                <td>{element?.label}</td>
                                                <td className="text-center" role='button'>
                                                    <div className="d-flex justify-content-center">
                                                        <div>
                                                            <Tooltip title={intl.formatMessage({ id: 'delete' })}>
                                                                <DeleteOutlined
                                                                    onClick={() => { 
                                                                        props?.deleteBankName({bank_name: element?.label, bank_id: element?.value});
                                                                        }}
                                                                    className="m-0 cu-font-bold cu-font-cancel"
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                        <div>&nbsp;</div>
                                                        <div>
                                                            <Tooltip title={intl.formatMessage({ id: 'edit' })}>
                                                                <EditOutlined
                                                                    className="fs-5"
                                                                onClick={() => {
                                                                        props?.editBankName({bank_name: element?.label, bank_id: element?.value});
                                                                        props?.setUpdatebtn(true);
                                                                    }}
                                                                />
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                        )
                                    })
                                })()
                            }
                        </tbody>
                    </table>
                </div>
                <div className="d-flex justify-content-between pb-2">
                    <div></div>
                    <div>
                        <Pagination
                            defaultCurrent={1}
                            current={props?.pageData?.page + 1}
                            pageSize={props?.paginationData?.pageSize}
                            total={props?.totalRecords || 0}
                            pageSizeOptions={[10, 20, 50, 100]}
                            locale={{ items_per_page: `${intl.formatMessage({ id: 'page' })}` }}
                            showTotal={(total: any, range: any) => `${range[0]}-${range[1]} ${intl.formatMessage({ id: 'of' })} ${total} ${intl.formatMessage({ id: 'items' })}`}
                            showSizeChanger={true}
                            onShowSizeChange={(page: any, pageSize: any) => {
                                props?.setPaginationData({
                                    ...props?.paginationData,
                                    pageSize: pageSize
                                });
                                props?.setPageData({
                                    size: pageSize,
                                    page: (props?.paginationData?.pageSize !== pageSize) ? 0 : page - 1,
                                });
                            }}
                            onChange={(page: any, pageSize: any) => {
                                props?.setPaginationData({
                                    pageSize: pageSize,
                                    page: page
                                });
                                props?.setPageData({
                                    size: pageSize,
                                    page: (props?.paginationData?.pageSize !== pageSize) ? 0 : page - 1,
                                });
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )

}

export default BankNameList;